import React from "react";
import StatusPill from "../components/StatusPill";
import StatCard from "../components/StatCard";
import Terminal from "../components/Terminal";
import { links } from "../lib/data";
import type { SectionKey } from "../lib/types";

interface HomeSectionProps {
  activeSection: SectionKey;
  onNavigate: (section: SectionKey) => void;
}

function HomeSection({ activeSection, onNavigate }: HomeSectionProps) {
  return (
    <div className="flex flex-col gap-10">
      {/* Hero */}
      <div className="opacity-0-start animate-fade-in-d1 max-w-xl">
        <StatusPill color="accent" className="mb-5">
          Open to opportunities
        </StatusPill>
        <h1 className="text-2xl sm:text-3xl font-bold leading-tight mt-4 mb-4">
          Eric Mwangi
        </h1>
        <p className="text-lg text-content-secondary leading-relaxed mb-2">
          Software Developer &amp; Creative Problem Solver
        </p>
        <p className="text-base text-content-muted leading-relaxed max-w-md">
          Building elegant solutions to complex problems. Focused on full-stack
          development, application security, and scalable architectures.
        </p>

        {/* Quick links */}
        <div className="flex flex-wrap gap-2.5 mt-6">
          <a
            href={links.github}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded text-sm font-medium no-underline text-content bg-bg-raised border border-border hover:-translate-y-px transition-all duration-150"
          >
             GitHub
          </a>
          <a
            href={links.email}
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded text-sm font-medium no-underline text-content bg-bg-raised border border-border hover:-translate-y-px transition-all duration-150"
          >
            ✉ Email
          </a>
          <a
            href={links.resume}
            download
            className="inline-flex items-center gap-1.5 px-4 py-2 rounded text-sm font-medium no-underline text-bg bg-accent border border-accent hover:-translate-y-px hover:shadow-glow transition-all duration-150"
          >
            Resume ↓
          </a>
        </div>
      </div>

      {/* Stats */}
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3.5">
        <StatCard label="Experience" value="5+ yrs" sub="since 2021" icon="▸" animationClass="animate-fade-in-d2" />
        <StatCard label="Projects" value="8+" sub="production apps" icon="□" animationClass="animate-fade-in-d3" />
        <StatCard label="Schools" value="13" sub="on SmartCampus" icon="◇" animationClass="animate-fade-in-d4" />
        <StatCard label="Focus" value="Full Stack" sub="+ security" icon="◈" animationClass="animate-fade-in-d5" />
      </div>

      {/* Terminal */}
      <div className="opacity-0-start animate-fade-in-d4">
        <div className="flex items-center gap-2 mb-3">
          <span className="text-xs font-mono text-content-muted uppercase tracking-widest">
            Interactive Terminal
          </span>
          <span className="flex-1 h-px bg-border" />
        </div>
        <Terminal section={activeSection} onNavigate={onNavigate} />
      </div>
    </div>
  );
}

export default HomeSection;